<template>
  <div>
    <h1>Manage Clients</h1>
    <div class="mt-5">
      <client-table :table-items="clientDetails" :database-items="clientDatabaseDetails" />
    </div>
  </div>
</template>

<script>
import ClientTable from '@/components/manageClients/ClientTable'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'manage-clients',
  components: {
    ClientTable
  },
  computed: {
    ...mapState('manageClient', ['clientDetails', 'clientDatabaseDetails'])
  },
  created() {
    this.getClientDetails()
    this.getClientDatabaseDetails()
  },
  methods: {
    ...mapActions('manageClient', ['getClientDetails', 'getClientDatabaseDetails'])
  }
}
</script>
